import App from './app';
import objectFitImages from 'object-fit-images';
import axios from 'axios';

require('es6-promise').polyfill();
require('./utils/polyfills');

objectFitImages();

axios.defaults.baseURL = window.options.rest_url;
axios.defaults.params = {
    lang: window.siteLang
};

/* eslint-disable no-new */
new App();



// WEBPACK FOOTER //
// ./src/main.js